module.exports = __webpack_public_path__ + "static/img/about_13.2bc31e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about_13.png
// module id = WDxb
// module chunks = 1